import {
    HStack, Text, VStack,
} from '@chakra-ui/react';
import { AccessIssuesWizardMachineContext } from '../machine/context';
import { useEntryMethodDetails } from '../hooks';
import { AccessIssuesWizardChangeEntryMethodLink } from './change-entry-method-link';

function AccessIssuesWizardProblemSetHeader() {
    const currentProblemSet = AccessIssuesWizardMachineContext.useSelector(
        // Guaranteed to be defined
        (state) => state.context.problemSet.current!
    );

    const currentProblemSetIdx = AccessIssuesWizardMachineContext.useSelector(
        // How many we've resolved so far + the one we're currently resolving
        (state) => state.context.problemSet.resolvedCount + 1
    );

    const totalProblemSetCount = AccessIssuesWizardMachineContext.useSelector(
        // Resolved problem sets + the ones still in the queue + the one we're currently resolving
        (state) => state.context.problemSet.resolvedCount
            + state.context.problemSet.queue.length
            + 1
    );

    const currentEntryMethod = AccessIssuesWizardMachineContext.useSelector(
        (state) => state.context.entryMethods.current
    );

    const entryMethodDefinition = useEntryMethodDetails(currentEntryMethod!);

    return (
        <VStack gap={0} alignItems="start" flexGrow={1}>
            <HStack alignItems="center">
                {
                    totalProblemSetCount > 1 && (
                        <Text fontSize="sm" color="muted.500">
                            {currentProblemSetIdx}
                            {' '}
                            of
                            {' '}
                            {totalProblemSetCount}
                            {' '}
                            access issues preventing
                            {' '}
                            {entryMethodDefinition.plural.toLocaleLowerCase()}
                        </Text>
                    )
                }
                {
                    totalProblemSetCount === 1 && (
                        <Text fontSize="sm" color="muted.500">
                            1 access issue preventing
                            {' '}
                            {entryMethodDefinition.plural.toLocaleLowerCase()}
                        </Text>
                    )
                }
            </HStack>

            <Text fontWeight="medium" fontSize="lg">
                Let&apos;s resolve:&nbsp;
                {currentProblemSet.public_name}
            </Text>

            {currentProblemSet.public_descriptions.map((text) => (
                <Text whiteSpace="pre-line">
                    {text}
                </Text>
            ))}

            <AccessIssuesWizardChangeEntryMethodLink />

        </VStack>
    );
}

export { AccessIssuesWizardProblemSetHeader };
